import type { ComponentProps, Key, ReactNode } from "react"
import { omit } from "lodash"
import { MenuItem } from "@mui/material"
import type { ModelSelectorListOption } from "./types"

export interface ModelSelectorOptionProps {
  option: ModelSelectorListOption
  label?: ReactNode
}

export function ModelSelectorOption({
  option,
  label,
  ...rest
}: ModelSelectorOptionProps & ComponentProps<typeof MenuItem> & { key?: Key }) {
  const menuItemProps = omit(rest, "key")
  return (
    <MenuItem value={option.id} {...menuItemProps}>
      <span className="model-selector-option-label">
        {label ?? option.name}
      </span>
    </MenuItem>
  )
}
